import { isStreamIQ, isToya } from '@/shared/lib'

export const getConfigService = async () => {
    if (isToya()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/toya/config/service/configServiceToya')
            return module.getApiConfigToya
        } catch (error) {
            console.warn(
                'getApiConfigToya module is missing. TOYA-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/services/features/getApiConfigStreamIQ')
            return module.getApiConfigStreamIQ
        } catch (error) {
            console.warn(
                'getApiConfigStreamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
